import React from "react";
import { Conversation, ChatActionType, Itinerary } from "../types";
import { FaCommentDots, FaMagnifyingGlass, FaMapLocationDot } from "react-icons/fa6";

interface ChatActionsProps {
  conversation: Conversation;
  action: string;
  itinerary: Itinerary | null;
  handleselectedAction: Function;
}

const ChatActions: React.FC<ChatActionsProps> = ({ conversation, action, itinerary, handleselectedAction }) => {

  return (
    <div className="d-flex justify-content-center py-3 bg-light">
      <div
        className="btn-group rounded-4 border border-primary"
        role="group"
        aria-label="Toggle button group"
      >
        <button
          type="button"
          className={`d-flex align-items-center btn btn-outline-primary border-0 rounded-4 ${
            action === ChatActionType.CHAT ? "active" : ""
          }`}
          onClick={() => handleselectedAction(ChatActionType.CHAT)}
        >
          <FaCommentDots className="me-1" />
          <span>Chat</span>
        </button>
        {itinerary && itinerary.data?.departure_date && (
          <button
            type="button"
            className={`d-flex align-items-center btn btn-outline-primary border-0 rounded-4 ${
              action === ChatActionType.ITINERARY ? "active" : ""
            }`}
            onClick={() => handleselectedAction(ChatActionType.ITINERARY)}
          >
            <FaMapLocationDot className="me-1" />
            <span>Itinerary</span>
          </button>
        )}

        <button
          type="button"
          className={`d-flex align-items-center btn btn-outline-primary border-0 rounded-4 ${
            action === ChatActionType.SEARCH ? "active" : ""
          }`}
          onClick={() => handleselectedAction(ChatActionType.SEARCH)}
        >
          <FaMagnifyingGlass className="me-1" />
          <span>Search</span>
        </button>
      </div>
    </div>
  );
};

export default ChatActions;
